import { convertTimetoMoment, trimObjectValues } from '@/utilz';
import type { AddressBookLocation } from '../../types';

export const shipmentAddressBookListApiToLocal = (data: AddressBookLocation[]) => {
  if (data?.length > 0) {
    return data.map((row) => {
      const phoneSplitted = row?.phone?.split('-');
      const countryCallingCode = phoneSplitted && phoneSplitted?.length > 1 ? phoneSplitted[0] : '';
      const phone = phoneSplitted && phoneSplitted?.length > 1 ? phoneSplitted[1] : phoneSplitted?.[0];
      const daysOfWeek = row?.daysOfWeek?.split('-');
      const hoursOfOperation = row?.hoursOfOperation?.split('-');
      return trimObjectValues({
        ...row,
        countryCallingCode: countryCallingCode,
        phone: phone,
        fromOperationDay: daysOfWeek?.[0],
        toOperationDay: daysOfWeek?.[1],
        fromOperationHours: convertTimetoMoment(hoursOfOperation?.[0]),
        toOperationHours: convertTimetoMoment(hoursOfOperation?.[1]),
      });
    });
  }
  return [];
};

export const normalizeAddressBookListApiToLocal = (data: {
  items: AddressBookLocation[];
  nextPage: number | undefined;
}) => {
  return {
    ...data,
    items: shipmentAddressBookListApiToLocal(data.items),
  };
};
